export const baseURL = "https://api.prod.assertion.cloud";
export const aws_region = "us-east-1";
export const custom_cognito_client_id = "7n28cddgdfipi16dglotupiai1";
export const identity_provider = "gehcsaml";
